import Button from "components/button/Button";
import cuid from "cuid";
import { formatDate } from "helper/dateFormat";
import moment from "moment";
import TicketCards from "pages/ExternalLinkEvents/EventComponents/EventInfo/TicketCards";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { setTicketsList } from "services/api/bulkClass";
import {
  DashLine,
  Description,
  DescriptionText,
  EventTitle,
  ReserveAction,
  ReserveLoginButton,
  RightSideContent,
  RightSideWrappr,
  SchoolCaption,
  SchoolLogin,
  SchoolName,
  TicketContainer,
} from "./Theme";
import { getAuthenticated, logout } from "utils/functions";

const BulkRightSide = () => {
  const isAuthenticated = getAuthenticated();
  const params = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const memberPortal = localStorage.getItem("memberPortal") === "true" || false;
  const { bulkClassDetails, ticketsList } = useSelector(
    (state) => state?.bulkClass
  );

  const [loading, setLoading] = useState(false);
  const [ticketData, setTicketData] = useState({
    variantInfo: [
      {
        name: "Enrollment/s",
        amount: 0,
        selectedQuantity: 1,
        forMemberOnly: false,
        infiniteQuantity: true,
      },
    ],
  });
  const [ticketsTypeList, setTicketsTypeList] = useState(ticketsList || []);
  const handleReserveLogin = () => {
    if (isAuthenticated) {
      handleReserveLogout();
      return;
    }
    localStorage.setItem("redirectUrl", `/school/bulk/${params?.id}`);
    window.location.href = "/login";
  };

  const handleReserveLogout = () => {
    localStorage.clear();
    window.location.reload();
  };

  const isExpiredBulkClass = () => {
    const startDateDiff = moment().diff(
      moment(bulkClassDetails?.bulkStartDate),
      "days"
    );
    const endDateDiff = moment().diff(
      bulkClassDetails?.bulkEndDate
        ? moment(bulkClassDetails?.bulkEndDate)
        : moment(),
      "days"
    );

    return startDateDiff < 0 || endDateDiff > 0;
  };

  const handleReserveButton = async () => {
    if (
      isExpiredBulkClass() ||
      !ticketsList?.length ||
      ticketsList?.length > 20 ||
      loading ||
      bulkClassDetails?.archived
    )
      return;
    history.push(`/school/bulk/${params?.id}/registration`);
  };

  const reserveLoginButton = useMemo(
    () => (isAuthenticated ? "Logout" : "Member? Log in here"),
    [isAuthenticated]
  );

  const schoolLogion = useMemo(() => (isAuthenticated ? "Logout" : "Login"), [
    isAuthenticated,
  ]);

  const handleQuantityChange = useCallback(
    (variantIndex, value, type) => {
      const newTicketData = { ...ticketData };
      newTicketData.variantInfo[variantIndex].selectedQuantity = value;
      setTicketData(newTicketData);

      if (type === "increment") {
        handleAddTicketId(variantIndex);
      }

      if (type === "decrement") {
        handleRemoveTicketId(ticketData.variantInfo[variantIndex].id);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [ticketData]
  );

  const handleAddTicketId = (variantIndex) => {
    const newTicketTypeList = [...ticketsTypeList];
    const ticketId = cuid();
    newTicketTypeList.push({
      id: ticketId,
      name: "Enrollment",
    });
    setTicketsTypeList(newTicketTypeList);
    dispatch(setTicketsList(newTicketTypeList));
  };

  const handleRemoveTicketId = (ticketId) => {
    const newTicketTypeList = [...ticketsTypeList];
    const ticketTypeIndex = newTicketTypeList.findIndex(
      (ticket) => ticket.id === ticketId
    );
    newTicketTypeList.splice(ticketTypeIndex, 1);
    setTicketsTypeList(newTicketTypeList);
    dispatch(setTicketsList(newTicketTypeList));
  };

  useEffect(() => {
    localStorage.removeItem("redirectUrl");
  }, []);

  return (
    <RightSideWrappr>
      <RightSideContent>
        {memberPortal && (
          <SchoolLogin>
            <ReserveLoginButton onClick={handleReserveLogin}>
              {schoolLogion}
            </ReserveLoginButton>
          </SchoolLogin>
        )}
        <EventTitle>
          <SchoolName>{bulkClassDetails?.bulkName}</SchoolName>
          <SchoolCaption>
            <span>
              Registration start:{" "}
              {formatDate({
                date: bulkClassDetails?.bulkStartDate,
                formatType: "defaultWithUTC",
              })}
            </span>
            <span>-</span>
            <span>
              Registration End:{" "}
              {formatDate({
                date: bulkClassDetails?.bulkEndDate,
                formatType: "defaultWithUTC",
              })}
            </span>
          </SchoolCaption>
        </EventTitle>

        <br />
        <Description>
          <span>Description</span>
          <DescriptionText>
            {bulkClassDetails?.description?.replace(/&lt;/g, "<") !==
              "<p></p>\n" && (
              <div className="drawer_description">
                <p
                  dangerouslySetInnerHTML={{
                    __html: bulkClassDetails?.description?.replace(
                      /&lt;/g,
                      "<"
                    ),
                  }}
                ></p>
              </div>
            )}
          </DescriptionText>
        </Description>

        <DashLine />
        <br />
        <TicketContainer>
          <TicketCards
            ticketList={ticketData}
            handleQuantityChange={(variantIndex, value, type) =>
              handleQuantityChange(variantIndex, value, type)
            }
            totalTicket={3}
            allowNonMembers={true}
          />
        </TicketContainer>
      </RightSideContent>
      <ReserveAction>
        {memberPortal ? (
          <ReserveLoginButton onClick={handleReserveLogin}>
            {reserveLoginButton}
          </ReserveLoginButton>
        ) : (
          <div></div>
        )}
        <Button
          onClick={handleReserveButton}
          disabled={
            isExpiredBulkClass() ||
            !ticketsList?.length ||
            ticketsList?.length > 20 ||
            loading ||
            bulkClassDetails?.archived
          }
          size="md"
        >
          Enroll
        </Button>
      </ReserveAction>
    </RightSideWrappr>
  );
};

export default BulkRightSide;
